import { render, staticRenderFns } from "./ClientMemberNotifications.vue?vue&type=template&id=e6fa5cb8&"
import script from "./ClientMemberNotifications.vue?vue&type=script&lang=js&"
export * from "./ClientMemberNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports